import { Box, Link, List, ListItem, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Terms of use (spec §17.1).
 *
 * Placeholder copy assembled from the spec. Final wording must be
 * reviewed by counsel before launch — see TODO(legal-review) markers.
 */
export function TermsPage() {
  return (
    <Stack spacing={3} sx={{ maxWidth: 'md' }}>
      <Typography variant="h1" component="h1">
        Terms of use
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Last updated: 2026-05-23. Placeholder text pending legal review.
      </Typography>

      <Box component="section" aria-labelledby="acceptance">
        <Typography id="acceptance" variant="h2" component="h2" sx={{ fontSize: '1.4rem', mb: 1 }}>
          1. Acceptance
        </Typography>
        <Typography variant="body1">
          By using Round Recon you agree to these Terms of use and our{' '}
          <Link component={RouterLink} to="/privacy">
            Privacy policy
          </Link>
          . If you do not agree, do not use the service.
        </Typography>
      </Box>

      <Box component="section" aria-labelledby="role">
        <Typography id="role" variant="h2" component="h2" sx={{ fontSize: '1.4rem', mb: 1 }}>
          2. Round Recon&apos;s role
        </Typography>
        <Typography variant="body1">
          Round Recon is a search and comparison platform for ammunition listings published by
          third-party retailers. We do not sell ammunition, accept payment, store payment data,
          collect tax, ship products, accept returns, or process refunds. All transactions occur on
          retailer websites under those retailers&apos; terms.
        </Typography>
      </Box>

      <Box component="section" aria-labelledby="user-responsibility-link">
        <Typography
          id="user-responsibility-link"
          variant="h2"
          component="h2"
          sx={{ fontSize: '1.4rem', mb: 1 }}
        >
          3. User responsibility
        </Typography>
        <Typography variant="body1">
          You are responsible for complying with all applicable federal, state, and local laws and
          confirming that any ammunition is lawful for you to purchase, possess, and receive. See
          our{' '}
          <Link component={RouterLink} to="/responsibility">
            User responsibility notice
          </Link>{' '}
          for the full statement.
        </Typography>
      </Box>

      <Box component="section" aria-labelledby="accounts">
        <Typography id="accounts" variant="h2" component="h2" sx={{ fontSize: '1.4rem', mb: 1 }}>
          4. Accounts
        </Typography>
        <Typography variant="body1">
          A Round Recon account is optional. If you create one, keep your credentials confidential
          and notify us if you suspect unauthorized access. You can export your data or delete your
          account from your dashboard at any time.
        </Typography>
      </Box>

      <Box component="section" aria-labelledby="prohibited-uses">
        <Typography
          id="prohibited-uses"
          variant="h2"
          component="h2"
          sx={{ fontSize: '1.4rem', mb: 1 }}
        >
          5. Prohibited uses
        </Typography>
        <List sx={{ pl: 2, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item', pl: 0 }}>
            Using the service to evade legal restrictions on ammunition purchase or possession.
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 0 }}>
            Scraping or otherwise automated bulk-retrieval of our listings without prior written
            permission.
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 0 }}>
            Impersonating another person, retailer, or organization.
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 0 }}>
            Interfering with the service&apos;s operation or security.
          </ListItem>
        </List>
      </Box>

      <Box component="section" aria-labelledby="disclaimers">
        <Typography id="disclaimers" variant="h2" component="h2" sx={{ fontSize: '1.4rem', mb: 1 }}>
          6. Disclaimers and limitation of liability
        </Typography>
        {/* TODO(legal-review): jurisdictional disclaimers, warranty
            disclaimers, indemnity language, choice of law, dispute
            resolution. Counsel to provide final wording. */}
        <Typography variant="body1">
          The service is provided &quot;as is&quot; without warranty of any kind. Round Recon does
          not guarantee the accuracy, completeness, or current availability of any listing. To the
          fullest extent permitted by law, Round Recon disclaims liability for any indirect,
          incidental, or consequential damages arising from your use of the service.
        </Typography>
      </Box>

      <Box component="section" aria-labelledby="changes">
        <Typography id="changes" variant="h2" component="h2" sx={{ fontSize: '1.4rem', mb: 1 }}>
          7. Changes
        </Typography>
        <Typography variant="body1">
          We may update these terms. Material changes will be announced on the site and via the
          email address on your account, if any. Continued use after a change constitutes
          acceptance.
        </Typography>
      </Box>

      <Box component="section" aria-labelledby="contact-terms">
        <Typography
          id="contact-terms"
          variant="h2"
          component="h2"
          sx={{ fontSize: '1.4rem', mb: 1 }}
        >
          8. Contact
        </Typography>
        <Typography variant="body1">
          Questions about these terms can be sent to support@roundrecon.com.
        </Typography>
      </Box>
    </Stack>
  );
}

export default TermsPage;
